import * as React from 'react';
import cx from 'classnames';
import { useDeviceType } from '../../../../responsive';
import { CloseButton } from '../../../../internal/components/CloseButton';
import { Overlay } from '../../../internal/components';
import { getStyles } from './styles';
/**
 * Компонент для рендера модального окна в виде окошка с крестиком внутри
 */
export function ModalWindowView(props) {
  var children = props.children,
    onClose = props.onClose,
    outside = props.outside,
    content = props.content,
    header = props.header,
    print = props.print,
    footer = props.footer,
    title = props.title,
    size = props.size,
    width = props.width,
    height = props.height,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    fixed = props.fixed,
    zIndex = props.zIndex;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType, size);
  return /*#__PURE__*/React.createElement(Overlay, {
    zIndex: zIndex,
    onClose: onClose,
    outside: outside,
    print: print
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles['container'], styles[size], fixed && styles['fixed'], !!header && styles['withHeader']),
    style: {
      width: width,
      height: height,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['window'],
    "aria-modal": "true",
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['head']
  }, /*#__PURE__*/React.createElement(CloseButton, {
    className: styles['close'],
    onClick: onClose,
    size: 16,
    theme: "dark"
  }), title && /*#__PURE__*/React.createElement("div", {
    className: cx(styles['title'])
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: styles['body']
  }, header && /*#__PURE__*/React.createElement("div", {
    className: styles['header']
  }, header), /*#__PURE__*/React.createElement("div", {
    className: styles['content-container']
  }, children || /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, content)), footer && /*#__PURE__*/React.createElement("div", {
    className: styles['footer']
  }, footer)))));
}
ModalWindowView.defaultProps = {
  size: 'M',
  fixed: false,
  outside: true,
  print: true
};